import moment from 'moment';
import { Column } from 'react-table';
import { UserDetails } from '../user/user';

export type ReportSummary = {
    id: string;
    id_short: string;
    status: ReportStatus;
    subject: string;
    reason: string;
    reportedObjectTitle: string;
    reportedObjectKey: string;
    reportedObjectId: string;
    link: string;
    createdAt: number[];
    createdAtDate: moment.Moment;
};

export type ReportDetails = {
    id: string;
    id_short: string;
    status: ReportStatus;
    subject: string;
    reason: string;
    reportedObjectTitle: string;
    reportedObjectKey: string;
    user: UserDetails;
    createdAt: number[];
    createdAtDate: moment.Moment;
};

export type ReportNew = {
    description: string;
    reason: string;
    commentId?: string;
    commentType?: string | null;
    problemId?: string;
    lectureId?: string;
    reportedUserId?: string;
    moduleId?: string;
    chapterId?: string;
    messageId?: string;
    type: string;
    typeApi?: string;
};

export const allReportsColumns: ReadonlyArray<Column> = [
    {
        Header: 'id',
        accessor: 'id',
        defaultCanSort: true,
    },
    {
        Header: 'reason',
        accessor: 'reason',
        defaultCanSort: true,
    },
    {
        Header: 'status',
        accessor: 'status_badge',
    },
    {
        Header: 'reported_at',
        accessor: 'createdAtDate',
        defaultCanSort: true,
    },
    {
        Header: 'entity',
        accessor: 'entity',
    },
];

export const allReportsColumnsAdmin: ReadonlyArray<Column> = [
    {
        Header: 'ID',
        accessor: 'id',
        defaultCanSort: true,
    },
    {
        Header: 'Reason',
        accessor: 'reason',
        defaultCanSort: true,
    },
    {
        Header: 'Status',
        accessor: 'status_badge',
    },
    {
        Header: 'Reported At',
        accessor: 'createdAtDate',
        defaultCanSort: true,
    },
    {
        Header: 'Entity',
        accessor: 'entity',
        defaultCanSort: true,
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    },
];

export enum ReportStatus {
    ACTIVE,
    REJECTED,
    ACCEPTED,
}

export enum ReportProblemReason {}
